import { useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { OpportunityStageEnum } from '../../../api';
import RequiredFormLabel from '../../RequiredFormLabel/RequiredFormLabel';

const OpportunityFunnelDriveItEasyForm = ({ finalState, opportunityValues, setOpportunityValues, activateDriveItEasy, setActivateDriveItEasy }) => {
    const { t } = useTranslation()
    const [buttonIsDisabled, setButtonIsDisabled] = useState<boolean>(false)
    const [showWarning, setShowWarning] = useState(false);
    useEffect(() => {
        setButtonIsDisabled(!opportunityValues.driveItEasy || !opportunityValues.targa || !opportunityValues.telaio || !opportunityValues.dataFineContrattoDriveItEasy)
    }, [opportunityValues])


    return (
        <Form>
            <Row>
                {/* Targa */}
                <Col md={4}>
                    <Form.Group className="mt-4">
                        <RequiredFormLabel
                            label={t('targa')}
                            required={false}
                            additionalRedLabelText={t('req_die')}
                            className="me-2"
                            htmlFor="targaAnchor"
                        />
                        <Form.Control
                            id="targaAnchor"
                            name="targa"
                            type="text"
                            value={opportunityValues.targa ?? ''}
                            maxLength={10}
                            onChange={(e) => {
                                const { value } = e.target;
                                if (value.length === 10) {
                                    setShowWarning(true);
                                } else {
                                    setShowWarning(false);
                                }
                                setOpportunityValues({
                                    ...opportunityValues,
                                    targa: e.target.value.trim(),
                                });
                            }}
                        />
                    </Form.Group>
                    {showWarning && <div className="text-danger">{t("licensePlate_no_more_than_10_chars")}</div>}

                </Col>

                {/* Telaio */}
                <Col md={4}>
                    <Form.Group className="mt-4">
                        <RequiredFormLabel
                            label={t('vehicle_frame')}
                            required={false}
                            additionalRedLabelText={t('req_die')}
                            className="me-2"
                            htmlFor="telaioAnchor"
                        />
                        <Form.Control
                            id="telaioAnchor"
                            name="telaio"
                            type="text"
                            value={opportunityValues.telaio ?? ''}
                            onChange={(e) => {
                                setOpportunityValues({
                                    ...opportunityValues,
                                    telaio: e.target.value.trim(),
                                });
                            }}
                        />
                    </Form.Group>
                </Col>
            </Row>

            <Row>
                {/* Data Fine Contratto */}
                <Col md={4}>
                    <Form.Group className="mt-4">
                        <RequiredFormLabel
                            label={t('date_end_contract')}
                            required={false}
                            additionalRedLabelText={t('req_die')}
                        />
                        <Form.Control
                            id="dateEndContractAnchor"
                            name="dataFineContrattoDriveItEasy"
                            type="date"
                            value={opportunityValues.dataFineContrattoDriveItEasy ?? ''}
                            onChange={(e) => {
                                setOpportunityValues({
                                    ...opportunityValues,
                                    dataFineContrattoDriveItEasy: e.target.value,
                                });
                            }}
                        />
                    </Form.Group>
                </Col>

            </Row>
            {finalState === OpportunityStageEnum.closed_won && (
                <Row className='d-flex justify-content-end mt-4'>
                    <Col md={4} className='d-flex justify-content-end'>
                        <Button
                            id="toggleDie"
                            variant={activateDriveItEasy ? 'light' : 'primary'}
                            className={`${activateDriveItEasy ? 'disable-btn' : 'enable-btn'}`}
                            onClick={() => setActivateDriveItEasy(!activateDriveItEasy)}
                            disabled={buttonIsDisabled}
                        >
                            {activateDriveItEasy ? t('deactivate_drive_it_easy') : t('activate_drive_it_easy')}
                        </Button>
                    </Col>
                </Row>
            )}
        </Form>
    )
}

export default OpportunityFunnelDriveItEasyForm;
